import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import BigNumber from 'bignumber.js';

import { selectCreatedQuote } from 'src/store/slice/quote/state';
import { selectMarketPrice } from 'src/store/slice/marketPrice/state';
import {
  selectPayment,
  selectCreatedPaymentAddress,
  selectTagType,
  selectTagValue,
} from 'src/store/slice/payment/state';

import { useWidgetHelp } from 'src/hook';
import { useAppContext } from 'src/context/useAppContext';

import ButtonCopy from 'src/components/buttonCopy';
import PopupQrCode from 'src/components/popups/popupQrCode';

import './address.scss';

const Address: React.FC = (): JSX.Element => {
  const { t } = useTranslation();

  const { isDefaultInvoice, isOpenDepositInvoice, isRequesSuccess } = useWidgetHelp();
  const { currency } = useAppContext();

  const payment = useSelector(selectPayment);
  const quote = useSelector(selectCreatedQuote);
  const marketPrice = useSelector(selectMarketPrice);

  const paymentAddress = useSelector(selectCreatedPaymentAddress);
  const tagType = useSelector(selectTagType)?.replace('_', ' ');
  const tagValue = useSelector(selectTagValue);

  const { currency_id: selectedCurrencyId } = currency;
  const { source_currency_amount, source_currency_id } = quote || marketPrice || { source_currency_amount: 0 };
  const { target_currency_amount_left } = payment || {};

  const targetCurrencyAmountLeft = new BigNumber((target_currency_amount_left || 0).toString()).toFormat();
  const sourceCurrencyAmount = new BigNumber(source_currency_amount.toString()).toFormat();

  return (
    <>
      <div className="address">
        <p className={`address-label ${!isRequesSuccess ? 'skeleton-loader' : ''}`}>
          {isDefaultInvoice &&
            t('LABEL_ADDRESS.SEND_EXACT_AMOUNT', {
              amount: source_currency_amount ? sourceCurrencyAmount : targetCurrencyAmountLeft,
              currency: source_currency_id || selectedCurrencyId,
            })}

          {isOpenDepositInvoice &&
            t('LABEL_ADDRESS.SEND_TO_ADDRESS', {
              currency: source_currency_id || selectedCurrencyId,
            })}
        </p>

        <div className={`address-field ${!isRequesSuccess ? 'skeleton-loader' : ''}`}>
          {paymentAddress}
          <ButtonCopy text={paymentAddress} />
        </div>
      </div>

      {tagType && tagValue && (
        <div className="tag-name">
          <p className={`tag-name-label ${!isRequesSuccess ? 'skeleton-loader' : ''}`}>
            {tagType.slice(0, 1).toUpperCase() + tagType.slice(1)}
          </p>
          <div className={`tag-name-field ${!isRequesSuccess ? 'skeleton-loader' : ''}`}>
            {tagValue}

            <PopupQrCode />
            <ButtonCopy text={tagValue} />
          </div>
        </div>
      )}
    </>
  );
};

export default Address;
